const WellnowBrandLogo = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="280" height="68" viewBox="0 0 280 68" fill="none">
			<g clipPath="url(#clip0_4130_8109)">
				<path
					d="M33.8938 36.9683C32.3902 36.9683 31.1547 38.198 31.1547 39.7159V51.6385C31.1547 53.1468 32.3806 54.3862 33.8938 54.3862C35.407 54.3862 36.6329 53.1565 36.6329 51.6385V39.7159C36.6329 38.2076 35.407 36.9683 33.8938 36.9683Z"
					fill="#FFB500"
				/>
				<path
					d="M33.8938 13.6133C32.3902 13.6133 31.1547 14.843 31.1547 16.361V28.2835C31.1547 29.7919 32.3806 31.0312 33.8938 31.0312C35.407 31.0312 36.6329 29.8015 36.6329 28.2835V16.361C36.6329 14.8526 35.407 13.6133 33.8938 13.6133Z"
					fill="#C721AB"
				/>
				<path
					d="M28.1954 31.252H16.31C14.8064 31.252 13.5709 32.4817 13.5709 33.9996C13.5709 35.5176 14.7968 36.7473 16.31 36.7473H28.1954C29.699 36.7473 30.9344 35.5176 30.9344 33.9996C30.9344 32.4817 29.7086 31.252 28.1954 31.252Z"
					fill="#7473BF"
				/>
				<path
					d="M51.4776 31.252H39.5922C38.0886 31.252 36.8531 32.4817 36.8531 33.9996C36.8531 35.5176 38.079 36.7473 39.5922 36.7473H51.4776C52.9812 36.7473 54.2167 35.5176 54.2167 33.9996C54.2167 32.4817 52.9908 31.252 51.4776 31.252Z"
					fill="#CD0E2D"
				/>
				<path
					d="M107.849 39.1017L101.471 20.9824H95.1498L88.7809 39.1017L82.7281 21.0401L82.709 20.9824H75.8229L85.5151 47.4792L85.5343 47.5272H91.8648L98.339 29.8019L104.794 47.4792L104.813 47.5272H111.134L120.817 21.0881L120.855 20.9824H113.969L107.849 39.1017Z"
					fill="#003592"
				/>
				<path
					d="M134.656 20.4824C128.009 20.4824 121.276 25.2188 121.276 34.2592C121.276 38.4191 122.713 41.945 125.443 44.4525C127.942 46.7582 131.361 48.0264 135.058 48.0264C139.406 48.0264 143.4 46.2682 145.737 43.3284L145.775 43.2804L142.643 39.9371L142.595 39.889L142.538 39.9371C140.709 41.5319 138.506 42.3004 135.805 42.3004C131.754 42.3004 128.795 40.3118 127.856 36.9684H147.499V36.9012C148.141 31.8766 147.106 27.6686 144.52 24.7288C142.145 22.0292 138.544 20.4824 134.637 20.4824H134.656ZM141.35 31.8478H127.76C128.718 27.8031 131.965 26.362 134.704 26.362C138.851 26.362 141.015 29.1001 141.35 31.8478Z"
					fill="#003592"
				/>
				<path d="M158.36 11.3462H151.435V47.527H158.36V11.3462Z" fill="#003592" />
				<path d="M170.293 11.3462H163.368V47.527H170.293V11.3462Z" fill="#003592" />
				<path
					d="M190.204 20.4824C186.747 20.4824 183.931 21.8755 182.236 24.4214V20.9916H175.311V47.5268H182.236V33.0391C182.236 29.1385 184.362 26.7175 187.781 26.7175C191.2 26.7175 193.326 29.1385 193.326 33.0391V47.5268H200.25V31.9246C200.25 24.7576 196.496 20.4824 190.213 20.4824H190.204Z"
					fill="#003592"
				/>
				<path
					d="M227.469 23.9987C224.941 21.7602 221.464 20.4824 217.93 20.4824C214.396 20.4824 210.891 21.7698 208.372 23.9987C205.508 26.535 203.995 30.08 203.995 34.2496C203.995 38.4191 205.508 41.9642 208.372 44.5005C210.9 46.739 214.377 48.0168 217.93 48.0168C221.483 48.0168 224.941 46.7294 227.469 44.5005C230.342 41.9546 231.865 38.4095 231.865 34.2496C231.865 30.0897 230.342 26.535 227.469 23.9987ZM217.93 41.7432C214.396 41.7432 210.814 39.1685 210.814 34.2592C210.814 29.3499 214.396 26.7752 217.93 26.7752C221.464 26.7752 224.988 29.3499 224.988 34.2592C224.988 39.1685 221.435 41.7432 217.93 41.7432Z"
					fill="#003592"
				/>
				<path
					d="M277.577 20.9824H270.691L264.571 39.1017L258.202 20.9824H251.872L245.503 39.1017L239.45 21.0401L239.431 20.9824H232.545L242.247 47.4792L242.266 47.5272H248.587L255.061 29.8019L261.516 47.4792L261.535 47.5272H267.856L277.539 21.0881L277.577 20.9824Z"
					fill="#003592"
				/>
				<path
					d="M33.8938 0C15.2086 0 0 15.2563 0 34C0 52.7437 15.2086 68 33.8938 68C52.579 68 67.7877 52.7437 67.7877 34C67.7877 15.2563 52.579 0 33.8938 0ZM33.8938 59.9684C19.6238 59.9684 8.00657 48.3244 8.00657 34C8.00657 19.6756 19.6142 8.03165 33.8938 8.03165C48.1735 8.03165 59.7811 19.6756 59.7811 34C59.7811 48.3244 48.1735 59.9684 33.8938 59.9684Z"
					fill="#003592"
				/>
				<path
					d="M274.579 45.2695L274.33 45.1734C273.918 45.0101 273.804 44.8564 273.804 44.6642C273.804 44.4144 274.005 44.2799 274.273 44.2799C274.541 44.2799 274.752 44.424 274.914 44.7315L275.451 44.4336C275.278 44.0397 274.895 43.6362 274.244 43.6362C273.593 43.6362 273.085 44.0301 273.085 44.6546C273.085 45.2214 273.507 45.5096 274.024 45.721L274.263 45.8075C274.646 45.9612 274.809 46.0861 274.809 46.3551C274.809 46.6817 274.56 46.8354 274.263 46.8354C273.88 46.8354 273.641 46.576 273.535 46.2878L272.951 46.5568C273.085 47.1044 273.612 47.4983 274.273 47.4983C274.934 47.4983 275.566 47.1237 275.566 46.3647C275.566 45.8267 275.24 45.5289 274.579 45.2695Z"
					fill="#003592"
				/>
				<path
					d="M277.979 46.5184L276.753 43.6938H275.958V47.4503H276.686V45.0869H276.705L277.711 47.4503H278.247L279.253 45.0869H279.282V47.4503H280V43.6938H279.205L277.979 46.5184Z"
					fill="#003592"
				/>
			</g>
			<defs>
				<clipPath id="clip0_4130_8109">
					<rect width="280" height="68" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export default WellnowBrandLogo;
